import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { IonUtilititesService } from './services/ion-utilities/ion-utilitites.service';
import { modals } from './modals/modals.module';

@Component({
  selector: 'app-root',
  templateUrl: 'app.component.html',
  styleUrls: ['app.component.scss'],
})
export class AppComponent implements OnInit {
  constructor(
    private _route: ActivatedRoute,
    private _router: Router,
    private _ion: IonUtilititesService) {
  }

  ngOnInit() {
    this.getQueryParams();
  }

  getQueryParams() {
    this._route.queryParams.subscribe(params => {
      console.log(params);
      const query = params.q;
      if (query) {
        console.log(query);
        if (query == 'terms-and-conditions') {
          console.log("Open terms and conditions");
          this._ion.openModal(modals.TermsComponent);
        }
        if (query == 'privacy-policy') {
          console.log("Open privacy policy");
          this._ion.openModal(modals.PrivacyComponent);
        }
        if (query == 'password_reset' && params.token) {
          console.log("Password reset");
          this._router.navigate(['password-reset'], { replaceUrl: true, queryParams: params });
        }
      }
    });
  }
}